import { AlertController, Platform, Slides, Nav } from 'ionic-angular';
import { Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { NavController, LoadingController, Content } from 'ionic-angular';
import { Network } from '@ionic-native/network';
import { Subscription } from 'rxjs';

import { AdicionarContatoPage } from '../adicionar-contato/adicionar-contato';
import { Area } from '../../models/area';
import { BrComDao } from '../../service/BrComDao';
import { BrComService } from '../../service/BrComService';
import { Contato } from '../../models/contato';
import { EmpresaLocalProvider } from '../../providers/empresa-local/empresa-local';
import { PushService } from '../../service/PushService';
import { TipoLayout } from '../../shared/interfaces';
import { MenuController } from 'ionic-angular';

import { ConversaContatoPage } from '../conversa-contato/conversa-contato';
import { ListaConversasPage } from '../lista-conversas/lista-conversas';
import { ConversaPage } from '../conversa/conversa';
import { NavProxyProvider } from '../../providers/nav-proxy/nav-proxy';


@Component({
  selector: 'page-inicial',
  templateUrl: 'inicial.html'
})
export class InicialPage {

  @ViewChild(Content) content: Content;
  @ViewChild(Slides) slides: Slides;
  @ViewChild(ConversaContatoPage) childRef: ConversaContatoPage;
  
  public userData: any;

  public empresa: any;
  public posicao = 0;
  public autenticado = false;
  public atalhos = [];
  public URLLogotipoEmpresa = "";
  public nomeEmpresa;
  private appDomain = "";
  public tipoLayout: TipoLayout;
  public areaSelecionada: Area;
  public contatoSelecionado: Contato;
  private subscriptions: Subscription;
  public listaPagina = ListaConversasPage;
  public conversaPagina = ConversaPage;

  @ViewChild('content') contentNav: Nav;
  @ViewChild('meny') menuNav: Nav;

  constructor(public lc: ChangeDetectorRef, 
    private brComService: BrComService,
    public alertCtrl: AlertController, 
    private pushService: PushService,
    public navCtrl: NavController, 
    private loadingCtrl: LoadingController, 
    public platform: Platform, 
    public network: Network, 
    public brComDao: BrComDao, 
    private empresaLocalProvider: EmpresaLocalProvider,
    private menuController: MenuController,
    private navProxyProvider: NavProxyProvider) {
      
    this.brComService.atualizaListaMensagensNaoLidas();
    this.brComService.notificaMensagemRecebidaPendente();
    this.empresa = empresaLocalProvider.getEmpresa();
    this.calcularVariaveis();
    this.subscriptions = new Subscription();
    this.definirVariaveisEmpresa();
    this.recarregarImagensQuandoConVoltar();
  }

  ngOnInit() {
    this.pushService.checkMsgServer(); // importante, serve para fazer a primeira busca de mensagens
    const subEmpresa = this.empresaLocalProvider.$empresa.skip(1).subscribe(
      (empresa: any) => {
        this.empresa = empresa;
        this.atualizarEmpresa();
      }
    )
    this.subscriptions.add(subEmpresa);
    this.navProxyProvider.setNavContent(this.contentNav);
    this.navProxyProvider.setNavMenu(this.menuNav);
    //this.navProxyProvider.setNavMain(this.navCtrl);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private async definirVariaveisEmpresa() {
    this.appDomain = this.brComService.readAppDomain();
  }

  ionViewWillEnter() {
    let rec = this.getEmpresaAtual();
    this.content.resize();
    if (this.autenticado) {
      this.brComService.confirmaUsuarioLogado(rec.CodEmpresa, rec.CodUsuario);
    }
    this.definirLayoutPreferencial(rec);
  }

  calcularVariaveis() {
    let rec = this.getEmpresaAtual();
    this.autenticado = rec.Autenticado;
    this.URLLogotipoEmpresa = this.obtemUrlImagemEmpresa();
    if (rec.Atalhos) {
      this.atalhos = rec.Atalhos;
    } else {
      this.atalhos = [];
    }
    this.nomeEmpresa = rec.NomeEmpresa;
    this.definirLayoutPreferencial(rec);
  }

  private definirLayoutPreferencial(rec: any): void {
    const layout = this.brComDao.recuperarLayoutPreferencial(rec.CodEmpresa);
    if (layout) {
      this.tipoLayout = layout;
    } else {
      this.brComDao.gravarLayoutPreferencial(rec.LayoutRotinas, rec.CodEmpresa);
      this.tipoLayout = rec.LayoutRotinas;
    }
  }

  public async facebook(): Promise<void> {
    const load = this.loadingCtrl.create({content: "Aguarde ..."});
    await load.present();
    const rec = this.getEmpresaAtual();
    await this.brComService.facebook(rec.Facebook);
    load.dismiss();
  }

  public reloadInfo() {
    this.empresa = this.getEmpresaAtual();
    this.calcularVariaveis();
    this.content.resize();
  }

  obtemUrlImagemEmpresa():string {
    const hashLogotipoEmpresa = this.obtemImagemEmpresa();
    return this.brComService.obtemUrlLogotipoEmpresa(hashLogotipoEmpresa);
  }

  obtemImagemEmpresa():string {
    let rec = this.getEmpresaAtual();
    if (rec && rec.HashLogotipoEmpresa)
      return rec.HashLogotipoEmpresa;
    else
      return "8db4380e774ad6f7e8c1aadb486b4290039cf0b7"; // logotipo InfoBr
  }

  private atualizarEmpresa(): void {
    if (this.autenticado){
      this.reloadInfo();
      try {
        this.lc.detectChanges();
      } catch (err) {
        console.log("desprezado erro em detectChanges InicialPage");
      }
    }
  }

  public isLayoutDefault(): boolean {
    return this.tipoLayout === TipoLayout.LISTA || this.tipoLayout === undefined;
  }

  public isLayoutAlternativo(): boolean {
    return this.tipoLayout === TipoLayout.GRADE;
  }

  public getEmpresaAtual(): any {
    return this.empresaLocalProvider.getEmpresa();
  }

  public alterarAutenticacao(autenticacao: boolean) {
    this.autenticado = autenticacao;
  }

  public recarregarImagensQuandoConVoltar(): void {
    const subConexao = this.network.onConnect().subscribe(
      () => {
        const timestamp = new Date().getTime();
        this.URLLogotipoEmpresa = `${this.URLLogotipoEmpresa}?${timestamp}`
        for(const atalho of this.atalhos) {
          atalho.imagem = `${atalho.imagem}?${timestamp}`
        }
      }
    );
    this.subscriptions.add(subConexao);
  }

  public alterarLayout(layout: string): void {
    let valorLayout = TipoLayout[layout.toUpperCase()];
    if (valorLayout) {
      this.tipoLayout = valorLayout;
    } else {
      this.tipoLayout = TipoLayout.LISTA;
    }
  }

  public adicionarConversa(): void {
    const empresaAtual = this.getEmpresaAtual();
    this.navCtrl.push(AdicionarContatoPage, {
      idUsuario: empresaAtual.IdUsuario,
      idEmpresa: empresaAtual.IdEmpresa
    }, {

    });
  }

  public toggleMenu() {
    const menu = this.menuController.get();
    if (!menu.enabled) {
      menu.enable(true);
    }
    this.menuController.toggle();
  }

  public selecionarArea(area: Area) {
    this.contatoSelecionado = undefined;
    this.areaSelecionada = area;
  }

  public selecionarContato(contato: Contato) {
    if (this.contatoSelecionado && this.contatoSelecionado.idContato === contato.idContato) {
      //já está selecionado
      return
    }
    this.areaSelecionada = undefined;
    this.contatoSelecionado = contato;
  }
}


// WEBPACK FOOTER //
// ./src/pages/inicial/inicial.ts